import { render, staticRenderFns } from "./RekeningPenarikan.vue?vue&type=template&id=8bb5fb64&scoped=true&"
import script from "./RekeningPenarikan.vue?vue&type=script&lang=js&"
export * from "./RekeningPenarikan.vue?vue&type=script&lang=js&"
import style0 from "./RekeningPenarikan.vue?vue&type=style&index=0&id=8bb5fb64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb5fb64",
  null
  
)

export default component.exports